export const NAVBAR_HEIGHT = 64;
export const MODAL_MIN_HEIGHT = 400;
export const MODAL_SIDE_WIDTH = 400;
export const MODAL_CENTER_WIDTH = 400;
export const CSS_AUTO = 'auto';
export const CSS_FULL_SIZE = '100%';
export const CSS_FLEX_NONE = 'none';
export const CMODAL_SEQ_COMPONENT = 'Cmodal';
export const CMODAL_SCROLL_DEBUG_FEATURE = 'sessions-list-scroll-fade';
export const CMODAL_LAYOUT_HIERARCHY_DEPTH = 10;
export const CMODAL_CENTER_BACKDROP_ANIMATION_MS = 100;
export const CMODAL_CENTER_SNAPSHOT_DELAY_MS = 500;
export const CMODAL_TILE_RADIUS = 48;
/**
 * The modal tile paints NO backdrop blur (overrides the Tile preset's 5px).
 * It sits directly over Cblurbackdrop, which already blurs the page behind the
 * modal — a second backdrop-filter on top of it bought no visible depth and made
 * every frame re-sample and re-blur an already-blurred region, which is what made
 * idle modals blink on missed frames.
 */
export const CMODAL_TILE_BACKDROP_BLUR = 0;
export const CMODAL_CENTER_BACKDROP_OPACITY = 0.7;
export const CMODAL_SIDE_BACKDROP_OPACITY = 0.3;
export const CMODAL_CENTER_BACKDROP_BLUR = 10;
export const CMODAL_SIDE_BACKDROP_BLUR = 5;
export const CMODAL_BACKDROP_TOP_OFFSET = 0;
export const CMODAL_MOBILE_SIDE_PADDING = 16;
export const CMODAL_SIDE_EDGE_MARGIN = 14;
export const CMODAL_SIDE_TOP_MARGIN = 5;
export const CMODAL_CONTENT_GAP = 16;
export const CMODAL_TITLE_GAP = 10;
